import hello from "@/views/hello";
import Login from "@/views/login";
import Home from "@/views/home";
import config from "@/views/config";
import PatientList from "@/views/patientList"
import Validate from "@/views/validate"

export const routes = [
    {
        path: '/agenda',
        component: hello,
        meta: {
            requiresAuth: true,
            requiresActive: true,
        }
    },
    {
        path: '/config',
        component: config,
        meta: {
            requiresAuth: true,
            requiresActive: true,
        }
    },
    {path: '/login', component: Login},
    {path: '/home', component: Home},
    {path: '/validate', component: Validate},
    {path: '/', component: Home},
    {
        path: '/patient-list',
        component: PatientList,
        meta: {
            requiresAuth: true,
            requiresActive: true,
        }
    },
];
